import classNames from 'classnames';

import s from './LayoutContainer.sss';

type LayoutContainerProps = React.HTMLProps<HTMLDivElement>;

export const LayoutContainer: React.FC<LayoutContainerProps> = ({
  className,
  ...props
}) => (
  <div
    className={classNames(s.root, className)}
    {...props}
  />
);
